import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { IMPORT_TYPES } from '../../utils/importTypes';

const STATUS_STYLE = {
  new: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  merge: 'bg-sky-50 text-sky-700 border-sky-200',
  duplicate: 'bg-slate-100 text-slate-500 border-slate-200',
  invalid: 'bg-red-50 text-red-700 border-red-200',
};
const STATUS_LABEL = { new: 'New', merge: 'Merge', duplicate: 'Skip', invalid: 'Invalid' };

// Column-mapping header + row-by-row preview table.
export default function ImportPreviewTable({ kind, headers, mapping, onMapChange, rows, preview }) {
  const fields = IMPORT_TYPES[kind].fields;
  const byIndex = Object.fromEntries((preview?.rows || []).map((r) => [r.index, r]));
  const shown = rows.slice(0, 200);
  return (
    <div className="border border-slate-200 rounded-md overflow-auto max-h-[45vh]" data-testid="import-preview-table">
      <table className="min-w-full text-xs">
        <thead className="bg-slate-50 sticky top-0 z-10">
          <tr>
            <th className="px-2 py-2 text-left font-bold uppercase text-slate-500 w-24">Status</th>
            {headers.map((h, i) => (
              <th key={i} className="px-2 py-1.5 text-left min-w-[150px]">
                <Select value={mapping[i] || 'skip'} onValueChange={(v) => onMapChange(i, v === 'skip' ? '' : v)}>
                  <SelectTrigger className="h-7 text-xs" data-testid={`import-map-${i}`}><SelectValue /></SelectTrigger>
                  <SelectContent className="z-[140]">
                    <SelectItem value="skip"><span className="text-slate-400">Ignore column</span></SelectItem>
                    {fields.map((f) => <SelectItem key={f.key} value={f.key}>{f.label}{f.required ? ' *' : ''}</SelectItem>)}
                  </SelectContent>
                </Select>
                <p className="mt-1 font-normal text-slate-400 truncate" title={h}>{h || `Column ${i + 1}`}</p>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {shown.map((r, ri) => {
            const p = byIndex[ri];
            return (
              <tr key={ri} className={p?.status === 'invalid' ? 'bg-red-50/40' : p?.status === 'duplicate' ? 'opacity-60' : ''} data-testid={`import-row-${ri}`}>
                <td className="px-2 py-1.5 align-top whitespace-nowrap">
                  {p ? (
                    <span className={`inline-block px-1.5 py-0.5 rounded border font-semibold ${STATUS_STYLE[p.status]}`} title={p.reason} data-testid={`import-row-status-${ri}`}>{STATUS_LABEL[p.status]}</span>
                  ) : <span className="text-slate-300">…</span>}
                  {p && p.status !== 'new' && <p className="text-[10px] text-slate-500 mt-0.5 max-w-[140px] whitespace-normal">{p.reason}</p>}
                </td>
                {headers.map((_, ci) => (
                  <td key={ci} className={`px-2 py-1.5 align-top ${mapping[ci] ? 'text-slate-800' : 'text-slate-300 line-through'}`}>{r[ci] || ''}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > shown.length && <p className="px-2 py-1.5 text-xs text-slate-500 bg-slate-50">Showing first {shown.length} of {rows.length} rows — all rows will be imported.</p>}
    </div>
  );
}
